import { style } from 'typestyle'
export const ml24 = style({ marginLeft: '24px' })
